module.exports = (parcelRequire.load("evt8e")).then(() => parcelRequire('dWWfH'));